import { lazy } from 'react';

const TransformerPageValidationMaterialConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/register-material-delivery',
			component: lazy(() => import('./TransformerPageRegisterMaterialDelivery'))
		}
	]
};

export default TransformerPageValidationMaterialConfig;
